/* IntelApps — Work/Portfolio Page */
import React, { useEffect } from 'react';
import Header from '../parts/Header.js';
import Footer from '../parts/Footer.js';
import PortfolioSection from '../parts/Portfolio.js';
import DiscussCTA from '../parts/Discuss.js';
import workHeroImg from '../assets/images/hero/work.png';

export default function ProjectPage() {
  useEffect(() => { document.title = 'IntelApps — Work'; }, []);

  return (
    <>
      <Header />
      <main>
        <section className="page-hero">
          <div className="container page-hero-grid">
            <div>
              <span className="eyebrow">Work</span>
              <h1>Real products. Real metrics. No mockups.</h1>
              <p className="page-hero-sub">A subset of recent launches — apps in stores, platforms in production, contracts on mainnet.</p>
            </div>
            <div className="page-hero-media">
              <img src={workHeroImg} alt="Product screens and shipped work" />
            </div>
          </div>
        </section>
        <PortfolioSection showFeatured showFilters />
        <DiscussCTA />
      </main>
      <Footer />
    </>
  );
}
